export default {
  query: '/auth/res/query', // 获取(全部)某个系统的资源列表信息
  syncVerifyResource: '/auth/res/syncVerifyResource', // 同步资源检测
  syncResource: '/auth/res/syncResource', // 同步资源
};



// WEBPACK FOOTER //
// ./src/api/resourceDevSync.js